export const COMPARISON_LIMIT = 10;